<template>
  <div>
    <div
      v-for="notification, index in notifications"
      :key="index"
      class="notification"
    >
      <div class="header">
        <div class="aside">
          <div class="profile-img-wrapper">
            <img
              src="@/assets/avatar/avatar-profile.svg"
              width="29"
              height="32"
            >
          </div>
          <div class="person-info">
            <span class="name">{{ notification.name }}</span>
            <span class="course">{{ notification.course }}</span>
          </div>
        </div>
        <p class="content">
          {{ notification.content }}
        </p>
        <div class="notification-date">
          <span class="date">{{ notification.date }}</span>
          <span class="hour">{{ notification.hour }}</span>
        </div>
      </div>
      <div class="footer">
        <button class="perfil">
          Visualizar Perfil
        </button>
        <button class="responder">
          Responder
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    name: "Notification",
    props: ['notifications']
}
</script>

<style lang="scss" scoped>
@import 'Layout.scss';
</style>